import { isObject } from "@pineapplelab/util";
import { IsAlphanumeric, IsEmail, IsNotEmpty, IsNumber, MaxLength } from "@pineapplelab/validators";
import { Paging } from "../paging";
import { FBase } from "./firebase.base";
import { postulationStateEnum } from "@app/enums/postulationState.enum";
import firebase from 'firebase/compat/app';
import { PagingOrderType } from "@pineapplelab/paging";

export class Postulation extends FBase {
  id: string = null;
  @IsNotEmpty({ label: 'Name' })
  @MaxLength(50, { label: 'Name' })
  @IsAlphanumeric({ label: 'Name', allowedCharacters: '- _@' })
  name: string = null;
  @IsNotEmpty({ label: 'Last Name' })
  @MaxLength(50, { label: 'Last Name' })
  @IsAlphanumeric({ label: 'Last Name', allowedCharacters: '- _@' })
  lastName: string = null;
  @IsEmail()
  email: string = null;
  cv: string = null;
  image: string = null;
  jobOfferId: string = null;
  state: postulationStateEnum = postulationStateEnum.PENDIENTE;
  dateOfBirth: firebase.firestore.Timestamp = null;
  @IsNotEmpty()
  phoneNumber: string = null;
  dniFront: string = null;
  dniBack: string = null;
  rejectNote: string = null;
  CVViewed: boolean = false;

  aiRating: number = null;
  aiRecommendation: string = null;
  aiEvaluationSummary: string = null;
  aiStrengths: string[] = null;
  aiConcerns: string[] = null;
  aiCriteriaBreakdown: any[] = null;
  aiPrivatePriorityMatch: { score: number } = null;
  aiMissingInformation: string[] = null;
  aiSuggestedInterviewQuestions: string[] = null;
  aiConfidence: number = null;
  aiCriteriaHash: string = null;
  aiCriteriaVersion: number = null;
  aiModel: string = null;
  aiEvaluatedAt: firebase.firestore.Timestamp = null;
  aiEvaluationStatus: 'pending' | 'completed' | 'failed' | 'no_cv' | null = null;
  aiTokensUsed: number = null;

  stepId: string = null;
  stepName: string = null;
  workflowInstanceId: string = null;
  workflowTemplateId: string = null;
  workflowStatus: string = null;
  currentWorkflowStepId: string = null;
  currentWorkflowStepName: string = null;
  currentWorkflowStepStatus: string = null;
  currentWorkflowStepType: string = null;
  workflowStepsCount: number = 0;
  workflowCompletedSteps: number = 0;

  __fileImage: File;
  __fileExtension: string;
  __fileCV: File;
  __dateOfBirth: Date;
  __dniFront: File;
  __dniBack: File;

  __currentStepName: string;
  __stepsProgress: number;
  __isFinalStep: boolean;

  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}
export namespace Postulation {
  export const PATH = 'postulations';
  export const PAGING = new Paging<Postulation>(<Paging.IPaging>{
    collection: PATH,
    orderOptions: [
      { field: 'email', label: 'Email', placeholder: 'Filter by email', dataType: Paging.dataType.string },
      { field: 'name', label: 'Name', placeholder: 'Filter by name', dataType: Paging.dataType.string },
      { field: 'created_at', label: 'New postulations', dataType: Paging.dataType.timestamp },
      { field: 'aiRating', label: 'AI Score', dataType: Paging.dataType.number },
    ],
    orderType: PagingOrderType.desc,
    orderBy: 'created_at',
  });
}
